import { VacationLocationPolicy } from '../../common/vacation/vacation.models';
import {
  GeneralSettingViewField,
  NON_NEGATIVE_NUMBER_MINIMUM,
  NUMBER_TYPE
} from './view-user-report.option';

export class ViewUserReportHelper {
  public static isNonNegativeFiniteNumber(value: number): boolean {
    return typeof value === NUMBER_TYPE
      && isFinite(value)
      && value >= NON_NEGATIVE_NUMBER_MINIMUM;
  }

  public static trackGeneralSetting(
    _index: number,
    field: GeneralSettingViewField
  ): string {
    return field.action;
  }

  public static trackVacationLocationPolicy(
    _index: number,
    policy: VacationLocationPolicy
  ): string {
    return policy.calendarMarkerId;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/view-user-report.helper.ts